import { Medal, Gem } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export const TIER_CONFIG: Record<string, { color: string; Icon: LucideIcon }> = {
  Bronze: { color: '#CD7F32', Icon: Medal },
  Silver: { color: '#C0C0C0', Icon: Medal },
  Gold: { color: '#FFD700', Icon: Medal },
  Platinum: { color: '#E5E4E2', Icon: Gem },
  Diamond: { color: '#B9F2FF', Icon: Gem },
};

export function getTierConfig(tierName: string | null): { color: string; Icon: LucideIcon } | null {
  if (!tierName || !tierName.trim()) return null;
  const key = tierName.charAt(0).toUpperCase() + tierName.slice(1).toLowerCase();
  return TIER_CONFIG[key] ?? TIER_CONFIG.Silver;
}
